@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../constants/spacing.module.less';

.ss-settings-modal-body {
  padding: @space-16 @space-16 @space-48;
  height: 100%;
}

.ss-settings-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: @space-8;
}
